export class TabModel {
  id?: string;
  title?: string;
  icon?: string;
  disabled?: boolean = false;
}